var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHome = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14.899,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#264D6D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.731 6.733-2.424-2.425V1.507a.917.917 0 0 0-1.835 0v.967L9.667.668c-.893-.892-2.445-.89-3.335.002L.268 6.733A.918.918 0 0 0 1.566 8.03l6.062-6.063a.541.541 0 0 1 .742 0l6.064 6.063a.915.915 0 0 0 1.297 0 .917.917 0 0 0 0-1.297Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.319 3.707a.45.45 0 0 0-.637 0L2.348 9.04a.451.451 0 0 0-.132.319v3.889c0 .912.74 1.652 1.653 1.652h2.64v-4.09H9.49v4.09h2.64c.913 0 1.653-.74 1.653-1.652v-3.89a.45.45 0 0 0-.132-.318L8.319 3.707Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home.59d70ac8.svg";
export { ForwardRef as ReactComponent };